<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{locale.option}}</h2>
      <div class="flexBox">
        <div class="flexInner flexFrame">
          <button class="btn btnWhite" @click="setDetailOption('new')">{{locale.editor_action_addoption}}</button>
          <div v-if="options.length > 0" class="shopOptionList">
            <draggable
              v-model="options"
              handle=".btnHandle"
              group="optionList"
              animation="300"
              class="optionList draggable"
              tag="ul">
              <li
                v-for="(opt, index) in options"
                :key="index"
                class="optionItem">
                <button v-if="!(opt.isBaseShopPos && opt.mustPosSync)" type="button" class="btnDel" @click="delOption(index)"></button>
                <button type="button" class="btnHandle"></button>
                <div v-if="opt" class="optionName" @click="setDetailOption(opt, index)">
                  <span v-if="opt.id" class="stkr">Store</span>
                  <span v-if="opt.presetId" class="stkr">Preset</span>
                  {{ opt.presetName || opt.title || opt.name[defaultLang] }}
                </div>
              </li>
            </draggable>
          </div>
        </div>
        <div class="flexInner flexFrame optionType">
          <div>
            <button
              v-for="(btn, index) in optionListType"
              :key="index"
              class="btn btnLoad"
              :class="{btnWhite: btn.id !== currentOptionListType}"
              @click="setOptionListType(btn.id)">{{ locale[btn.name] }}</button>
          </div>
          <div class="mt5">
            <input type="text" class="input searchInput" v-model="searchWord[currentOptionListType]" placeholder="option(preset) name or pid">
          </div>
          <OptionListAll
            v-show="currentOptionListType === 'optionListAll'"
            ref="optionListAll"
            :locale="locale"
            :filterIds="optionItemIds"
            :searchWord="searchWord.optionListAll"
            :shopItemId="shopItemId"
            :disabledItemIds="disabledItemIds"
            :mustPosSync="mustPosSync"
            @update="setOptionListAll"
            @clicked="addOptionItem" />
          <div
            v-show="currentOptionListType === 'optionPresets'"
            class="shopOptionList">
            <ul
              class="optionList clickable">
              <li
                v-for="(opt, index) in filteredOptionPresets"
                :key="index"
                class="optionItem"
                :class="{disabled: !isSelectable(opt)}"
                @click="addOptionItem(opt)">
                <span v-if="opt.presetId" class="stkr">Preset</span>
                {{ opt.presetName }}
              </li>
              <li v-if="filteredOptionPresets.length <= 0" class="optionItem">{{locale.select_option_nodata}}</li>
            </ul>
          </div>
          
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
    <CreateOption
      v-if="detailOption"
      :locale="locale"
      :id="detailOption.id"
      :shopItemId="shopItemId"
      :optionId="detailOption.optionId"
      :isApply="true"
      :optionData="detailOption"
      :savedOptionIds="savedOptionIds"
      @apply="applyOptionItem"
      @reload="reloadOptionListAll"
      @close="setDetailOption(null)" />
    <CreateOptionPreset
      v-if="detailOptionPreset"
      :locale="locale"
      :presetId="detailOptionPreset.presetId"
      :isApply="true"
      :optionData="detailOptionPreset"
      @close="setDetailOption(null)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import CreateOption from './CreateOption'
import CreateOptionPreset from './CreateOptionPreset'
import OptionListAll from './OptionListAll'

export default {
  name: 'CompositeOption',
  props: [
    'locale',
    'shopItemId',
    'optionList',
    'savedOptionIds',
    'mustPosSync' // mustPosSync이면 isBasePos인 옵션을 추가할 수 없음(이미 정해진 옵션만 가능)
  ],
  components: {
    draggable,
    CreateOption,
    CreateOptionPreset,
    OptionListAll
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    optionItemIds () {
      return this.options.map(x => x.id || x.presetId)
    },
    disabledItemIds () {
      const presetItemIds = [...new Set([].concat(...this.options.filter(item => item.presetId && item.optionIds).map(item => item.optionIds)))]
      return presetItemIds
    },
    currentOptionListType () {
      return this.optionListType.find(x => x.isActive).id
    },
    currentOptionList () {
      const optionListType = this.currentOptionListType
      return this[optionListType]
    },
    filteredOptionPresets () {
      const word = this.searchWord.optionPresets
      const filterIds = this.optionItemIds || []
      return this.optionPresets.filter(x => (!word || x.presetName.includes(word)) && !filterIds.includes(x.presetId))
    }
  },
  watch: {
    optionList: {
      handler () {
        this.syncOptions()
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    await this.getPresetList()
  },
  data () {
    return {
      optionListType: [
        {
          id: 'optionListAll',
          name: 'options_all',
          isActive: true
        },
        {
          id: 'optionPresets',
          name: 'option_preset',
          isActive: false
        }
      ],
      options: [],
      optionPresets: [],
      optionListAll: [],
      detailOption: null,
      detailOptionIndex: null,
      detailOptionPreset: null,
      searchWord: {
        optionListAll: '',
        optionPresets: ''
      }
    }
  },
  methods: {
    async getPresetList () {
      this.$store.commit('onLoading', true)
      const getPreset = await this.$store.dispatch('shop/getShopPresetList', 'option')
      const presetList = getPreset && getPreset.message && getPreset.message.preset
      if (presetList) {
        this.optionPresets = presetList
      }
      this.$store.commit('onLoading', false)

      this.syncOptions()
    },

    setOptionListAll (list) {
      this.optionListAll = this._.cloneDeep(list) || []
      this.syncOptions()
    },

    syncOptions () {
      if (!this.optionList || !Array.isArray(this.optionList)) return
      if (!this.optionListAll || this.optionListAll.length <= 0) return
      if (!this.optionPresets) return

      const optionListAll = this.optionListAll
      const optionPresets = this.optionPresets

      this.options = this.optionList
        .map(item => {
          const activeItemIds = item.activeItemIds || null

          if (item.id) {
            const found = optionListAll.find(x => x.id === item.id)
            return found ? { ...found, activeItemIds } : null
          }

          if (item.presetId) {
            const found = optionPresets.find(x => x.presetId === item.presetId)
            return found || null
          }

          return item || null
        })
        .filter(Boolean)
        .map(item => {
          return {
            ...item,
            ...(item.id && {
              title: item.title || item.name?.[this.defaultLang] || ''
            })
          }
        })
    },
    reloadOptionListAll () { // 옵션관리에 저장 후 모든 옵션 리스트 재호출
      if (this.$refs.optionListAll) {
        this.$refs.optionListAll.getOptionListAll()
      }
    },
    isSelectable (item) {
      const optId = item.id
      const presetId = item.presetId
      if (optId) {
        // 설정된 프리셋 옵션에 포함되어 있다면 옵션 추가 불가
        return this.options.length > 0 ? !this.options.find(item => item.optionIds && item.optionIds.includes(optId)) : true
      }
      if (presetId) {
        // 설정된 옵션이 프리셋 옵션의 아이템이라면 프리셋 추가 불가
        const optionIds = item.presetOptItemIds || []
        return this.options.length > 0 ? !this.options.find(item => optionIds.includes(item.id)) : true
      }
    },
    addOptionItem (item) {
      const optionData = item.id
        ? { id: item.id, title: (item.title || item.name[this.defaultLang]) }
        : item.presetId
          ? { presetId: item.presetId, presetName: item.presetName, optionIds: item.presetOptItemIds }
          : null
      const isSelectable = this.isSelectable(item)
      if (isSelectable && optionData) {
        this.options.push(optionData)
      }
    },
    delOption (index) {
      this.options = this.options.filter((x, i) => i !== index)
    },
    openCreateOptionPreset () {
      this.createOptionPreset = true
    },
    closeCreateOptionPreset () {
      this.createOptionPreset = false
    },
    setOptionListType (id) {
      this.optionListType = this.optionListType.map(x => {
        return {
          ...x,
          isActive: x.id === id
        }
      })
    },
    setDetailOption (option, index) {
      if (!option) {
        this.detailOption = null
        this.detailOptionPreset = null
      } else if (option.presetId) {
        this.detailOptionPreset = option
      } else {
        this.detailOption = option
      }
      this.detailOptionIndex = !isNaN(index) ? index : null
      this.$emit('apply')
    },
    applyOptionItem (data) {
      const detailOptionIndex = this.detailOptionIndex !== null
      if (detailOptionIndex) {
        const index = this.detailOptionIndex
        this.options = this.options.map((x, i) => {
          return i === index ? data : x
        })
      } else {
        this.options.push(data)
      }
      this.setDetailOption(null)
    },
    close () {
      this.$emit('close')
    },
    apply () {
      this.$emit('apply', this.options)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 720px;
  }
}
.btnLoad {
  padding-left: 8px;
  padding-right: 8px;
  & + .btnLoad {
    margin-left: 4px;
  }
}
.shopOptionList {
  .optionItem {
    padding-right: 60px;
  }
}
</style>
